import { createSlice } from '@reduxjs/toolkit';

export const shop = createSlice({
  name: 'shops',
  initialState: {
    shop: {
      name: '',
      description: '',
      bannerUrl: '',
      logoUrl: '',
      faq: [],
      restock: [],
      productCategories: {
        categories: []
      },
      productSubCategories: {
        subcategories: []
      }
    },
    activeCourseLessons: [],
    membershipTypes: [],
    printfulProduct: [],
    memberships: [],
    digitalContractsTemplates: [],
    products: [],
    productRecipes: [],
    productFilterRecipes: [],
    cart: {},
    favorites: {},
    productSales: { data: [], total: 0 },
    courseSales: [],
    membershipSales: [],
    courses: [],
    courseInCart: {},
    inventoryList: [],
    inventoryPosOrder: [],
    couponList: [],
    countryData: [],
    selectedCoupon: {},
    shopItems: [],
    categories: [],
    printfulProd: [],
    shopTaxes: [],
    selectedTaxLocations: [],
    productBrands: []
  },
  reducers: {
    setShopReducer: (state, action) => {
      state.shop = action?.payload;
    },
    setProductsReducer: (state, action) => {
      state.products = action?.payload;
    },
    setProductBrandsReducer: (state, action) => {
      state.productBrands = action?.payload;
    },
    setProductRecipesReducer: (state, action) => {
      state.productRecipes = action?.payload;
    },
    setProductRecipesFilterReducer: (state, action) => {
      state.productFilterRecipes = action?.payload;
    },
    setCartReducer: (state, action) => {
      state.cart = action?.payload;
    },
    setFavoriteReducer: (state, action) => {
      state.favorites = action?.payload;
    },
    setProductSalesReducer: (state, action) => {
      state.productSales.data = action?.payload?.data;
      state.productSales.total = action?.payload?.total;
    },
    setCourseSalesReducer: (state, action) => {
      state.courseSales = action?.payload;
    },

    setInventoryListReduces: (state, action) => {
      state.inventoryList = action?.payload;
    },
    setMembershipTypesReducer: (state, action) => {
      state.membershipTypes = action?.payload;
    },
    setMembershipsReducer: (state, action) => {
      state.memberships = action?.payload;
    },
    setMembershipSalesReducer: (state, action) => {
      state.membershipSales = action?.payload;
    },
    setCoursesReducer: (state, action) => {
      state.courses = action?.payload;
    },
    setCourseInCartReducer: (state, action) => {
      state.courseInCart = action?.payload;
    },
    setDigitalContractsTemplatesReducer: (state, action) => {
      state.digitalContractsTemplates = action?.payload;
    },
    setCouponListReducer: (state, action) => {
      state.couponList = action?.payload;
    },
    getCountryDetailPrintful: (state, action) => {
      state.countryData = action.payload;
    },
    setSelectedCouponReducer: (state, action) => {
      state.selectedCoupon = action?.payload;
    },
    setShopItemsReducer: (state, action) => {
      state.shopItems = action?.payload;
    },
    setShopTaxesReducer: (state, action) => {
      state.shopTaxes = action?.payload;
    },
    setSelectedTaxLocationsReducer: (state, action) => {
      state.selectedTaxLocations = action?.payload;
    },
    getPrintfulProdReducer: (state, action) => {
      state.printfulProduct = action?.payload;
    },
    setCategoriesReducer: (state, action) => {
      state.categories = action?.payload;
    },
    getPrintfulProductReducer: (state, action) => {
      state.printfulProd = action?.payload;
    },
    fetchActiveCourseLessons: (state, action) => {
      state.activeCourseLessons = action?.payload;
    },
  }
});

export const {
  setShopReducer,
  getPrintfulProdReducer,
  setCategoriesReducer,
  setProductsReducer,
  setProductRecipesReducer,
  setProductRecipesFilterReducer,
  setCartReducer,
  setMembershipTypesReducer,
  setFavoriteReducer,
  setProductSalesReducer,
  setMembershipsReducer,
  setMembershipSalesReducer,
  setCoursesReducer,
  setCourseInCartReducer,
  setCourseSalesReducer,
  setDigitalContractsTemplatesReducer,
  setCouponListReducer,
  getCountryDetailPrintful,
  setSelectedCouponReducer,
  setShopItemsReducer,
  getPrintfulProductReducer,
  setShopTaxesReducer,
  setSelectedTaxLocationsReducer,
  setProductBrandsReducer,
  fetchActiveCourseLessons
} = shop.actions;

export default shop.reducer;
